import tableActionsMixin from '@/agilis/components/DataTableV2/common/tableActionsMixin'
import UnStyledLink from '@/agilis/components/UnstyledLink/UnstyledLink.vue'
import deleteMixin from '@/agilis/components/DataTableV2/common/deleteMixin'
import renderMixin from '@/agilis/components/DataTableV2/common/renderMixin'
import authorizationMixin from '@/agilis/components/DataTableV2/common/authorizationMixin'
import dumpUserActionMixin from '@/agilis/components/DataTableV2/common/dumpUserActionMixin'
import configurationMixin from '@/agilis/components/DataTableV2/common/configurationMixin'
import kanbanMixin from '@/applications/scrum/mixins/kanbanMixin'

export default {
  name: 'TrackerKanban',
  mixins: [
    authorizationMixin,
    dumpUserActionMixin,
    configurationMixin,
    deleteMixin,
    tableActionsMixin,
    renderMixin,
    kanbanMixin
  ],

  props: {
    disableDrag: {
      default: false,
      type: Boolean
    },
    items: Array,
    computedHeaders: Array,
    options: Object,
    fetchData: Function
  },

  created () {
    // Tune options: lastUser activity > configuration > defaults
    // const route = this.dumpRoute
    // const userLastActivity = this.userActivities(route) || {}
    this.options.itemsPerPage = -1
    this.options.page = 1

    // this.applyFilter(userLastActivity.filter)
  },

  components: {
    UnStyledLink
  }
}
